<template>
    <div class="paket-list p-d-10">
        <div v-for="(data, key) in dataList" :key="`card-pesan-${key}`" class="m-d-16">
            <SOSlotCard
                :id="`msg-${data.id}`"
                :card-type="'none'"
                @loadMore="doLoadMore"
                @toogleCard="toggleCard"
                :last-id="getLastId"
            >
                <template v-slot:card_head>
                    <div>
                        <div class="p-x-2 d-flex-between-center">
                            <div class="d-flex" style="align-items: baseline;">
                                <label class="m-d-0 m-r-4 f-cont nama-cs">{{ data.nama_customer }}</label>
                                <label class="m-d-0 f-12 f-c-midgrey f-regular">+{{ data.number }}</label>
                            </div>
                            <div
                                class="status-pesan"
                                :class="{
                                    warning:
                                        statusPesan(data.status) === 'Antrian' ||
                                        statusPesan(data.status) === 'Diproses',
                                    gagal: statusPesan(data.status) === 'Gagal',
                                    sukses: statusPesan(data.status) === 'Terkirim',
                                }"
                            >
                                <label class="m-d-0 f-12 f-regular">
                                    {{ statusPesan(data.status) }}
                                </label>
                            </div>
                        </div>
                        <div class="f-c-red f-12 f-regular" v-if="statusPesan(data.status) === 'Gagal'">
                            <SOIconBase width="12" height="12" viewBox="0 0 18 17">
                                <template v-slot:icon>
                                    <WarningTriangle1817 icon-fill="#964040" />
                                </template>
                            </SOIconBase>
                            {{ data.reason }}
                        </div>
                    </div>
                </template>
                <template v-slot:card_body>
                    <div style="padding-left: 2px; padding-right: 2px;">
                        <div class="text-msg">
                            <div class="d-flex-between-center">
                                <div class="text-transaksi">
                                    {{ jenisTransaksi(data.idpayload) }}
                                </div>
                                <button
                                    class="btn-share"
                                    @click="doResend(data.id)"
                                    v-if="statusPesan(data.status) === 'Gagal'"
                                    :disabled="isFetching && !isLoadMore && selectedMessage === data.id"
                                >
                                    <span
                                        class="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                        v-if="isFetching && !isLoadMore && selectedMessage === data.id"
                                    ></span>
                                    <div v-else>
                                        <SOIconBase width="14" height="14" view-box="0 0 24 24">
                                            <template v-slot:icon>
                                                <Mail2424 icon-fill="#206CFF" />
                                            </template>
                                        </SOIconBase>
                                        <span class="m-l-4">Kirim Ulang</span>
                                    </div>
                                </button>
                            </div>
                            <div class="msg" v-html="getTextFormated(data.text)"></div>
                            <div class="d-flex-between-center f-12 f-semi foot">
                                <div @click="showDetailMsg(data)">
                                    <label class="m-d-0 f-c-blue m-r-6">Lihat detail</label>
                                    <IconBased width="10" height="6">
                                        <template v-slot:icons>
                                            <NextDown />
                                        </template>
                                    </IconBased>
                                </div>
                                <div>
                                    <label class="m-d-0">
                                        {{ $moment(data.status_at).format("Do MMM YYYY, HH:mm") }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </SOSlotCard>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";

import IconBased from "../components/iconPack/IconBased.vue";
import NextDown from "../components/iconPack/NextDown.vue";

import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import WarningTriangle1817 from "@/so-components/global/icons/iconPacks/WarningTriangle1817.vue";
import Mail2424 from "@/so-components/global/icons/iconPacks/Mail2424.vue";

import { moduleName } from "../store/state";

export default {
    name: "CardPesan",
    props: {
        dataList: {
            type: Array,
            required: true,
        },
    },
    components: {
        SOSlotCard,
        IconBased,
        NextDown,
        SOIconBase,
        WarningTriangle1817,
        Mail2424,
    },
    data() {
        return {
            selectedMessage: null,
        };
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            isLoadMore: "isLoadMore",
            pagePesan: "pagePesan",
            endPesan: "endPesan",
            totalListPesan: "totalListPesan",
            jenisTransaksi: "getJenisTransaksi",
            statusPesan: "getStatusPesan",
            customer: "customer",
        }),
        getLastId() {
            return this.endPesan.id ? `msg-${this.endPesan.id}` : "";
        },
        getIdDevice() {
            return this.$route.params.id_device;
        },
        getTextFormated() {
            return (text) => {
                return text.replace(/\n/g, "<br />").replace(/\*([^\*\~]+)\*/g, "<b>$1</b>");
            };
        },
    },
    methods: {
        ...mapActions({
            getHistoryPesanV2: `${moduleName}/getHistoryPesanV2`,
            setLoadMore: `${moduleName}/setLoadMore`,
            toggleDisplayPesan: `${moduleName}/toggleDisplayPesan`,
            resendMessage: `${moduleName}/resendMessage`,
            setFetching: `${moduleName}/setFetching`,
            setResponse: `${moduleName}/setResponse`,
            resetListPesan: `${moduleName}/resetListPesan`,
            resetPagePesan: `${moduleName}/resetPagePesan`,
        }),
        showDetailMsg(data) {
            this.$router.push({
                name: "wa_autosender.detail_perangkat.riwayat_pesan.detail_message",
                params: { id_message: data.id },
            });
        },
        async doLoadMore() {
            if (this.totalListPesan > this.pagePesan.length) {
                if (!this.isFetching) {
                    let { number } = this.customer;
                    await this.setLoadMore(true);
                    await this.getHistoryPesanV2({ idMesin: this.getIdDevice, nomor: number !== "all" ? number : "" });
                }
            }
        },
        toggleCard(data) {
            this.toggleDisplayPesan(data);
        },
        doResend(id_pesan) {
            this.selectedMessage = id_pesan;
            this.resendMessage({ id_pesan })
                .then((res) => {
                    let { status, code, data, msg } = res.data;
                    if (status && code === 200) {
                        this.setFetching(false);
                        this.$toast.success(msg);
                        this.reloadList();
                        this.setResponse(resulter.successResult(msg));
                    } else {
                        this.setResponse(resulter.errorResult(msg));
                        this.setFetching(false);
                        this.$toast.error(msg);
                    }
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.setResponse(resulter.errorResult(e));
                    this.$toast.error(e);
                });
        },
        async reloadList() {
            let { number } = this.customer;
            await this.resetListPesan();
            await this.resetPagePesan();
            await this.getHistoryPesanV2({ idMesin: this.getIdDevice, nomor: number !== "all" ? number : "" });
        },
    },
};
</script>
<style scoped>
.btn-share {
    border: 1px solid;
    border-radius: 3px;
    box-sizing: border-box;
    background: white;
    color: #206cff;
    font-size: 12px;
    padding: 2px 8px;
    display: flex;
    align-items: center;
}
.p-x-2 {
    padding-left: 2px;
    padding-right: 2px;
}
.text-msg {
    background: #fafafa;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    padding: 0px 10px;
}
.text-msg .msg {
    display: block;
    display: -webkit-box;
    height: 40px;
    overflow: hidden;
    line-height: 1.5;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.text-transaksi {
    background: #ededed;
    border-radius: 8px 0px 8px 0px;
    width: fit-content;
    padding: 2px 10px;
    margin-bottom: 6px;
    margin-left: -10px;
}
.status-pesan {
    width: fit-content;
    padding: 0px 4px;
    border-radius: 3px;
}
.gagal {
    background-color: #fff1f1;
    color: #964040;
}
.sukses {
    background-color: #e8fcee;
    color: #40964c;
}
.warning {
    background-color: #fff8e1;
    color: #c29500;
}

.foot {
    padding-top: 4px;
    padding-bottom: 4px;
}

.nama-cs {
    max-width: 75px;
}

@media (min-width: 350px) {
    .nama-cs {
        max-width: 105px;
    }
}

@media (min-width: 370px) {
    .nama-cs {
        max-width: 127px;
    }
}

@media (min-width: 400px) {
    .nama-cs {
        max-width: 150px;
    }
}

@media (min-width: 450px) {
    .nama-cs {
        max-width: 200px;
    }
}

@media (min-width: 470px) {
    .nama-cs {
        max-width: 230px;
    }
}
</style>
